var Config = {
    apiUrl: "https://api.uhomeenergy.com:7443/",
    wssUrl: "wss://api.uhomeenergy.com:7443/ws/pusher",
    wssUrlV2: "wss://api.uhomeenergy.com:7443/ws/pusher/v2",
    wssInverterUrl: "wss://api.uhomeenergy.com:7443/ws-inverter/pusher",
    appName_General: "BMS",
    appName_IMS: "IMS",
    appName_Tip_General: "Batteries Management System",
    appName_Tip_IMS: "Inverters Management System",
    appIcon: "images/Uhome.png",
    burningPacketSize: 200,
    burningPacketSize_inverter: 240,
    gaodeMapKey: "cc0df822deda5bd6a5b0a728d268e245",
}

export default Config;